"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.resultsDefinition = void 0;
exports.makePvs = makePvs;
const property_1 = require("@genesys/property");
const resultGroupNames = __importStar(require("./result-group-names"));
const resultNames = __importStar(require("./result-names"));
exports.resultsDefinition = [
    {
        sortNo: 2,
        propertyName: resultNames.fanSpeed,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 4,
        propertyName: resultNames.maxFanSpeed,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 6,
        propertyName: resultNames.staticPressure,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 8,
        propertyName: resultNames.totalPressure,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 10,
        propertyName: resultNames.velocityPressure,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 12,
        propertyName: resultNames.systemEffectPressureDrop,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 34,
        propertyName: resultNames.outletVelocity,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 14,
        propertyName: resultNames.shaftPower,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 16,
        propertyName: resultNames.fanShaftMechanicalEfficiency,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 18,
        propertyName: resultNames.fanShaftStaticEfficiency,
        group: resultGroupNames.fanResults
    },
    {
        sortNo: 2,
        propertyName: resultNames.gridPower,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 6,
        propertyName: resultNames.motorPowerAtSpeed,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 8,
        propertyName: resultNames.motorSpeed,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 10,
        propertyName: resultNames.maximumMotorSpeed,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 12,
        propertyName: resultNames.motorFrequency,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 14,
        propertyName: resultNames.maximumMotorFrequency,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 16,
        propertyName: resultNames.current,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 18,
        propertyName: resultNames.fanDriveMotorMechanicalEfficiency,
        group: resultGroupNames.motorAndDriveResults
    },
    {
        sortNo: 20,
        propertyName: resultNames.fanDriveMotorStaticEfficiency,
        group: resultGroupNames.motorAndDriveResults
    }
];
function makePvs(result) {
    let pvs = property_1.PropertyValueSet.Empty;
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanSpeed, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanSpeed)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.maxFanSpeed, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.maximumFanSpeed)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.staticPressure, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.staticPressure)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.totalPressure, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.totalPressure)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.velocityPressure, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.velocityPressure)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.systemEffectPressureDrop, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.systemEffectPressureDrop)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanShaftMechanicalEfficiency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanShaftMechanicalEfficiency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanShaftStaticEfficiency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanShaftStaticEfficiency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.shaftPower, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.shaftPower)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.motorPowerAtSpeed, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.motorPowerAtSpeed)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.outletVelocity, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.outletVelocity)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanDriveMotorMechanicalEfficiency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanDriveMotorMechanicalEfficiency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.fanDriveMotorStaticEfficiency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fanDriveMotorStaticEfficiency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.gridPower, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.gridPower)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.motorSpeed, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.motorSpeed)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.maximumMotorSpeed, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.maximumMotorSpeed)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.motorFrequency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.motorFrequency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.maximumMotorFrequency, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.maximumMotorFrequency)), pvs);
    pvs = property_1.PropertyValueSet.setAmount(resultNames.current, property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.current)), pvs);
    return pvs;
}
//# sourceMappingURL=result-definition.js.map